<template>
  <div style="border-bottom: 1px #f0f0f0 solid;">
    <el-row style="height: 1.5rem">
      <el-col :span="5" class="flex-center" style="height: 100%">
        <el-avatar :size="50" :src="avatarUrl" fit="fill"></el-avatar>
      </el-col>
      <el-col :span="19">
        <el-row style="height: .6rem">
          <div class="doctor-name">{{name}}<span class="doctor-profession" style="padding-left: .3rem">{{profession}}</span></div>
<!--          <el-col :span="7" class="doctor-name">{{name}}</el-col>-->
<!--          <el-col :span="10" class="doctor-profession">{{profession}}</el-col>-->
        </el-row>
        <el-row style="height: .4rem">
          <el-col :span="5" class="doctor-price">￥{{price}}</el-col>
          <el-col :span="11">
            <el-rate class="doctor-rate" v-model="rate" disabled text-color="#ff9900"></el-rate>
          </el-col>
          <el-col :span="5" class="doctor-surplus">
            <div style="background-color: #409eff;text-align: center;border-radius: .2rem;color: #ffffff;font-size: .24rem">余号:{{surplus}}</div>
          </el-col>
          <el-col :span="3" style="line-height: .4rem;text-align: center;font-size: .28rem;">
            <i class="el-icon-arrow-right" style="font-weight: 900;color: #8a8a8a;font-size: .32rem;line-height: .4rem"></i>
          </el-col>
        </el-row>
        <el-row style="height: .5rem">
          <el-col :span="4" class="doctor-introduce">擅长：</el-col>
          <el-col :span="20" class="doctor-introduce" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{introduce}}</el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
      data(){
        return{
        }
      },
      props:{
        //头像地址
        avatarUrl:{
          type:String,
          default:'static/img/doctor.png'
        },
        //医师姓名
        name:{
          type:String,
          default:'刘迪莲'
        },
        //医师职业
        profession:{
          type:String,
          default:'主治医师'
        },
        //医师单价
        price:{
          type:Number,
          default:7.00
        },
        //医师评分
        rate:{
          type:Number,
          default:5
        },
        //医师剩余号数
        surplus:{
          type:Number,
          default:23
        },
        //医师擅长
        introduce:{
          type:String,
          default:'妇产科常见病及多发病的诊治。妇产科常见病及多发病的诊治。'
        }
      }
    }
</script>

<style scoped>
  .doctor-name{
    line-height: .6rem;
    font-size: .3rem;
  }
  .doctor-profession{
    line-height: .6rem;
    font-size: .3rem;
    color: #555555;
  }
  .doctor-price{
    line-height: .4rem;
    font-size: .28rem;
    color: #e6a23c;
  }
  .doctor-surplus{
    line-height: .4rem;
  }
  .doctor-rate{
    height: .4rem;
    display: flex;
    align-items: center;
    /*去除点击有蓝色边框*/
    outline:none;
  }
  .doctor-introduce{
    line-height: .5rem;
    font-size: .28rem;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/DoctorInfo.vue